import { Eye, Plus, Phone, CalendarDays, Bookmark, CreditCard, Timer, Zap } from 'lucide-react';

/**
 * Static navigation + action registry for the CommandBar.
 *
 * Exported as a factory so the consumer can inject a `navigate` callback
 * (avoids importing react-router-dom in this constants module).
 */
export function buildNavResults(navigate) {
  return [
    { type: 'nav',    group: 'Navigate', icon: <Eye className="w-4 h-4" />,          title: 'Go to Command Desk',  action: () => navigate('/') },
    { type: 'nav',    group: 'Navigate', icon: <Eye className="w-4 h-4" />,          title: 'Go to Inbox Triage',  action: () => navigate('/inbox') },
    { type: 'nav',    group: 'Navigate', icon: <Phone className="w-4 h-4" />,        title: 'Go to Calls Queue',   action: () => navigate('/calls') },
    { type: 'nav',    group: 'Navigate', icon: <CalendarDays className="w-4 h-4" />, title: 'Go to Calendar Grid', action: () => navigate('/calendar') },
    { type: 'nav',    group: 'Navigate', icon: <Bookmark className="w-4 h-4" />,     title: 'Go to Reading Desk',  action: () => navigate('/reading') },
    { type: 'nav',    group: 'Navigate', icon: <CreditCard className="w-4 h-4" />,   title: 'Go to Payments Board',action: () => navigate('/payments') },
    { type: 'nav',    group: 'Navigate', icon: <Eye className="w-4 h-4" />,          title: 'Go to Control Room',  action: () => navigate('/analytics') },
    { type: 'action', group: 'Create',   icon: <Plus className="w-4 h-4" />,         title: 'Create new task',     subtitle: 'Add a task to today' },
    { type: 'action', group: 'Create',   icon: <Phone className="w-4 h-4" />,        title: 'Add a new call',      subtitle: 'Open the calls queue form' },
    { type: 'action', group: 'Flow',     icon: <Timer className="w-4 h-4" />,        title: 'Start focus mode',    subtitle: 'Enter deep work session' },
    { type: 'action', group: 'Flow',     icon: <Zap className="w-4 h-4" />,          title: 'Plan my day',         subtitle: 'AI-powered scheduling' },
  ];
}

export const INTENT_LABELS = {
  CREATE_TASK:    'Create task',
  SCHEDULE_TASK:  'Schedule task',
  START_FOCUS:    'Start focus',
  CREATE_CALL:    'Add call',
  CREATE_READING: 'Save link',
  CREATE_PAYMENT: 'Add payment',
  NAVIGATE:       'Navigate',
  PLAN_DAY:       'Plan day',
  SEARCH:         'Search',
};

export const getIntentLabel = (intent) => INTENT_LABELS[intent] || intent;
